/**
 * Kravtypen på norsk (og engelsk), brukt som ledetekst foran radteksten i
 * søkervisningen: «Fartstid: 1080 dager som overstyrmann».
 *
 * Katalogen er en forkortet utgave av kraveditorens `requirementCatalog` — her
 * trengs bare visningsnavnet, ikke redigeringsmetadataene. Ukjente kravtyper
 * gir INGEN ledetekst: en søker skal ikke møte kildedataenes egne stikkord
 * («PS_Foo»), og modellen tåler at ledeteksten mangler.
 */

/** Kravtype → meldings-id. Alt som ikke står her får ingen ledetekst. */
const REQUIREMENT_TYPE_MESSAGE_IDS: { [type: string]: string } = {
  Education: 'certreq.requirementtype.education',
  Course: 'certreq.requirementtype.course',
  OnboardTraining: 'certreq.requirementtype.onboardtraining',
  Assessment: 'certreq.requirementtype.assessment',
  Competency: 'certreq.requirementtype.competency',
  Bekreftelse: 'certreq.requirementtype.confirmation',
  // Erklæringen søkeren krysser av for — se `declarations.ts`.
  Declaration: 'certreq.requirementtype.declaration',
  Certificate: 'certreq.requirementtype.certificate',
  SeagoingService: 'certreq.requirementtype.seagoingservice',
  Age: 'certreq.requirementtype.age',
  HealthCertificate: 'certreq.requirementtype.healthcertificate',
  HealthCertificateRecreational: 'certreq.requirementtype.healthcertificaterecreational',
  Health_validDate: 'certreq.requirementtype.health',
  Health_security: 'certreq.requirementtype.health',
  Health_otherwork: 'certreq.requirementtype.health',
  Health_bridgeguard: 'certreq.requirementtype.health',
  Health_color_vision: 'certreq.requirementtype.health',
  Health_recreationalCraftMaster: 'certreq.requirementtype.health',
  YearsSinceCompletion: 'certreq.requirementtype.yearssincecompletion',
  DateOfCompletion: 'certreq.requirementtype.dateofcompletion',
  IdCard: 'certreq.requirementtype.idcard',
  ProfilePicture: 'certreq.requirementtype.profilepicture',
  Signature: 'certreq.requirementtype.signature',
};

const KNOWN_TYPES = Object.keys(REQUIREMENT_TYPE_MESSAGE_IDS);

/**
 * Ontologien lager suffiksvarianter av flere kravtyper
 * (`Certificate_SEOF_valid`, `YearsSinceCompletion_SOF`). Denne slår varianten
 * tilbake til grunntypen, slik at «Sertifikat» også dekker variantene.
 */
export const baseRequirementType = (type?: string | null): string | undefined => {
  if (!type) return undefined;
  if (REQUIREMENT_TYPE_MESSAGE_IDS[type]) return type;

  const matches = KNOWN_TYPES.filter((candidate) => type.startsWith(`${candidate}_`)).sort(
    (a, b) => b.length - a.length
  );

  return matches[0];
};

/** Meldings-id-en for en kravtype, eller undefined for en type vi ikke kjenner. */
export const requirementTypeMessageId = (type?: string | null): string | undefined => {
  const base = baseRequirementType(type);
  return base ? REQUIREMENT_TYPE_MESSAGE_IDS[base] : undefined;
};
